import {format} from 'url';
import {SET_DESTINATION_INFOGRAPHIC} from './action-types';
import {getPrefix} from '../utils/urls';

export const setDestinationInfographic = (payload) => {
    return {
        type: SET_DESTINATION_INFOGRAPHIC,
        payload
    };
};

export const fetchDestinationInfographic = (lbsId) => {
    return (dispatch) => {
        const requestUrl = format({
            pathname: `/${getPrefix()}/api/infographic`,
            query: {lbsId}
        });

        return fetch(requestUrl, {
            credentials: 'same-origin'
        })
            .then((res) => {
                if (!res.ok) {
                    throw new Error(
                        'Failed loading destination infographic'
                    );
                }
                return res.json();
            })
            .then((data) =>
                dispatch(setDestinationInfographic(data))
            )
            .catch((err) => console.log(err)); // eslint-disable-line no-console
    };
};